// @flow
import { Record } from 'immutable';
import EmptyList from './EmptyList';
import Catalog from './Catalog';

type ResponseShape = {
  ugc_id: UgcId,
  ugctype: '' | ResponseUgcType,
  ugc_archetype: '',
  created_date: string,
  updated_date: string,
  author: string,
  location: string,
  text: string,
  email: string,
  expert: boolean,
  source: string,
  ip_address: string,
  device_id: string,
  locale: string,
  catalog: Catalog,
};
const defaultResponse: ResponseShape = {
  ugc_id: '',
  ugctype: '',
  ugc_archetype: '',
  created_date: '',
  updated_date: '',
  published: null,
  author: '',
  location: '',
  text: '',
  email: '',
  expert: true,
  source: '',
  ip_address: '',
  device_id: '',
  locale: '',
  ugc_related_content: EmptyList,
  catalog: Catalog.Empty,
};

const ResponseRecord = Record(defaultResponse);

export default class Response extends ResponseRecord {
  static createWithData(data: { [string]: any }) {
    return new Response({
      ...data,
      text: data.text ? data.text : data.value || '',
    });
  }
}



// WEBPACK FOOTER //
// ./src/models/Response.js